import { DefaultLogLevel, isLogLevel } from "./types";

export const env = process.env.ENV ?? process.env.NODE_ENV ?? "prod";
export const logLevel = isLogLevel(process.env.LOG_LEVEL) ? process.env.LOG_LEVEL : DefaultLogLevel;
